export const metatagifront = {
  Page: {
    "meta-tagi": {
      Title:
        "Narty ze SkiOne.pl - wyjazdy na narty 2022/2023, zima 2022/2023 | Grupa TravelOne.pl",
      Description:
        "Narty i snowboard - najniższe ceny gwarantowane ::: free ski Włochy, skipass Austria, Francja, Słowacja, Sylwester w górach!",
      Keywords: [],
    },
  },
};
